// extracted by mini-css-extract-plugin
export default {"inputGroup":"RuleName_inputGroup__xtMxZ","label":"RuleName_label__OX9N6","input":"RuleName_input__PH5Uz"};